import React, { useContext } from 'react'
import { Checkbox } from './Checkbox';
import { ValidationState, InlineOrBlockSize } from '../Types';
import { LabelContext } from '../labels/LabelContext';

export interface RadioListOption<T> {
    label: string | JSX.Element
    value: T
    state?: ValidationState
}

export interface RadioListProps<T> {
    /**
     * Used to generate Radio Button HTML ids
     */
    id: string,
    /**
     * Options specifying Radio Buttons
     */
    options: RadioListOption<T>[],
    /**
     * Value of the selected Radio Button
     */
    value: T,
    /**
     * Value change handler
     */
    onChange: (v: T) => any,
    /**
     * Validation state
     */
    state?: ValidationState;
    /**
     * Size
     */
    size?: InlineOrBlockSize;
    /**
     * Disables element
     */
    disabled?: boolean;
}

/**
 * Displays lists of radio buttons
 */



export const RadioList = <T extends unknown>(props: RadioListProps<T>) => {
    const labelCtx = useContext(LabelContext);
    
    return( 
    <div role="radiogroup" 
         aria-labelledby={labelCtx.describedBy || (labelCtx.id ? `${labelCtx.id}-label` : undefined)}
         tabIndex={0}>
        {props.options.map(o => <Checkbox key={`${o.value}`}
            type="radio"
            id={`${props.id}__${o.value}`}
            name={`${props.id}`}
            label={o.label}
            checked={props.value == o.value}
            onChange={v => v && props.onChange(o.value)}
            state={props.state || o.state}
            size={props.size}
            disabled={props.disabled}
            describedby={' '}
        />)}
    </div>)
}